import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface MapPinIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

export const MapPinIcon: React.FC<MapPinIconProps> = ({
  size = 18,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();

  return (
    <Svg {...props} width={size} height={size} viewBox="0 0 12 12" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.6 5C9.6 5.38798 9.42701 5.9441 9.01204 6.64955C8.60999 7.33303 8.05342 8.03499 7.46408 8.68326C6.94504 9.25421 6.42238 9.7598 6 10.1465C5.57762 9.7598 5.05496 9.25421 4.53592 8.68326C3.94658 8.03499 3.39001 7.33303 2.98796 6.64955C2.57299 5.9441 2.4 5.38798 2.4 5C2.4 2.81705 3.96718 1.4 6 1.4C8.03282 1.4 9.6 2.81705 9.6 5ZM11 5C11 8 6 12 6 12C6 12 1 8 1 5C1 2 3.23858 0 6 0C8.76142 0 11 2 11 5ZM6.6 5C6.6 5.33137 6.33137 5.6 6 5.6C5.66863 5.6 5.4 5.33137 5.4 5C5.4 4.66863 5.66863 4.4 6 4.4C6.33137 4.4 6.6 4.66863 6.6 5ZM8 5C8 6.10457 7.10457 7 6 7C4.89543 7 4 6.10457 4 5C4 3.89543 4.89543 3 6 3C7.10457 3 8 3.89543 8 5Z"
        fill={colors[color]}
      />
    </Svg>
  );
};
